export default __webpack_public_path__ + "static/media/Path 5678.33cbdae1.svg";